module.exports = __webpack_public_path__ + "static/media/waste_detection.a1c61269.jpg";